import React, { Component } from 'react'
import Footer from './Footer.jsx'
import Popup from 'reactjs-popup'
import Enter from './Enter'


// JS
import $ from 'jquery';
import './home/Morphext-2.4.4/dist/morphext.js'

// STYLES
import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/magnific-popup.css'
import './home/css/styles.css'
import 'bootstrap/dist/css/bootstrap.min.css'
// Morphtext
import 'animate.css/animate.css'

// IMAGES
import mime from './home/images/mime.png'
import logan from './home/images/logan.png'
import karl from './home/images/karl.png'
import beth from './home/images/beth.png'
import Jim from './home/images/Jim.png'
import aboutUs from './home/images/balloon.png'
class Home extends Component {

  // MORPH TEXT - TICKETS TO: THEATER, SPORTS, ETC (CAROUSEL LIKE FEATURE)
  componentDidMount = () => {
    $("#js-rotating").Morphext({
      animation: "bounce",
      separator: ",",
      speed: 900,
    })

    // NUMBER TICKER - STILL WORKING ON IT
    // $('#showCount').each(function () {
    //   console.log("this")
    //   $(this).prop('Counter', 0).animate({
    //     Counter: $(this).text()
    //   }, {
    //     duration: 100000,
    //     easing: 'swing',
    //     step: function (now) {
    //       $(this).text(Math.ceil(now));
    //     }
    //   })
    // })
  }

  render() {
    return (
      <div>

        {/* MAIN STAGE */}
        <header id="header" className="header">
          <div className="header-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="text-container">
                    <h1 className="ticketsTo">Tickets to <span id="js-rotating">theater, sports, live music, comedy shows, LIFE!</span></h1>
                    <div>
                      <p className="p-heading p-large" id="headingOne">America's premier seatfilling company.</p>
                    </div>
                    {/* <p className="p-heading p-large" id="headingTwo">No one likes empty seats, not the performers, management, or the audience. Help end the empty seat crisis today!</p> */}
                    <Popup trigger={<button id="enterButton" className="btn-solid-lg page-scroll animate__animated animate__rubberBand  animate__slower"> Enter</button>} position="" closeOnDocumentClick>
                      <Enter />
                    </Popup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* WHAT IS SEATSTIR? */}
        <div id="intro" className="basic-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="text-container">
                  <div className="section-title"><span className="seatstirIs">Seatstir</span></div>
                  <h2 className="realLifeStream">a real-life streaming service</h2>
                  <p className="realLifeStream2">We provide members with tickets to a
                  variety of live shows and entertainment experiences.
                  </p><p className="realLifeStream2">Our
                  members perform a valuable service: helping be a good audience
                  & loving to fill empty seats. </p>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="image-container">
                  <img className="img-fluid" src={mime} alt="alternative" />
                </div>
              </div>
            </div>
            <div>
              <p className="testimonial-text">"My family and I are really enjoying all the exposure to the arts!"</p>
              <div className="testimonial-author"> - Katrina W, Minneapolis</div>
            </div>
          </div>
        </div>

        {/* FONTAWESOME PROMO CARDS */}
        <div className="cards-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <span className="fa-stack">
                    <span className="hexagon"></span>
                    <i className="fas fa-baseball-ball fa-stack-1x"></i>
                  </span>
                  <div className="card-body" id="faCards">
                    <h4 className="card-title">Front row of life</h4>
                    <p className="cardBody">Members get first-come, first-served access to a
                    variety of show and event offers.</p>
                  </div>
                </div>
                <div className="card">
                  <span className="fa-stack">
                    <span className="hexagon"></span>
                    <i className="fas fa-music fa-stack-1x"></i>
                  </span>
                  <div className="card-body" id="faCards">
                    <h4 className="card-title">Have fun</h4>
                    <p className="cardBody">Live theatre, music, comedy, sports, festivals, art shows, and so much more</p>
                  </div>
                </div>
                <div className="card">
                  <span className="fa-stack">
                    <span className="hexagon"></span>
                    <i className="fas fa-couch fa-stack-1x"></i>
                  </span>
                  <div className="card-body" id="faCards">
                    <h4 className="card-title couchTitle">Off the couch</h4>
                    <p className="cardBody couchCard">Tickets as often as you like. Enjoy a night out once in a while,
                    or see every show, it’s up to you!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MEMBERSHIPS */}
        <div id="services" className="cards-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title">Ready?</div>
                <h2>Memberships</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  {/* <div className="card-image">
                    <img className="img-fluid" id="membershipPic" src={ballet1} alt="alternative" />
                  </div> */}
                  <div className="card-body">
                    <h3 className="card-title">Plus One</h3>
                    <p>Reserve up to two (2) free tickets for each event reservation and attend an unlimited
                    number
                    of available shows and events offered through SeatStir located in your local metro area.
                                </p>
                    <ul className="list-unstyled li-space-lg">
                      <li className="media cardBullet">
                        <i className="fas fa-square greenbullet"></i>
                        <div >No cost per ticket</div>
                      </li>
                      <li className="media cardBullet">
                        <i className="fas fa-square greenbullet"></i>
                        <div >Renews annually</div>
                      </li>
                    </ul>
                    <p className="price"> <span>$12 </span> monthly</p>
                  </div>
                  <div className="button-container">
                    <a className="btn-solid-reg page-scroll" href="/memberships">JOIN</a>
                  </div>
                </div>
                <div className="card">
                  {/* <div className="card-image">
                    <img className="img-fluid" id="membershipPic" src={concert} alt="alternative" />
                  </div> */}
                  <div className="card-body">
                    <h3 className="card-title">VIP</h3>
                    <p>Reserve up to two (2) free tickets for each event reservation and attend an unlimited
                    number
                    of available shows and events offered through SeatStir located in your local metro area.</p>
                    <ul className="list-unstyled li-space-lg">
                      <li className="media cardBullet">
                        <i className="fas fa-square greenbullet"></i>
                        <div>Always something to do</div>
                      </li>
                      <li className="media cardBullet">
                        <i className="fas fa-square greenbullet"></i>
                        <div>Renews annually</div>
                      </li>
                    </ul>
                    <p className="price"> <span>$19</span> monthly</p>
                  </div>
                  <div className="button-container">
                    <a className="btn-solid-reg page-scroll" href="/memberships">JOIN</a>
                  </div>
                </div>
                <div className="card">
                  {/* <div className="card-image">
                    <img className="img-fluid" id="membershipPic" src={membership2} alt="alternative" />
                  </div> */}
                  <div className="card-body">
                    <h3 className="card-title">Fam-plan</h3>
                    <p>Reserve up to two (2) free tickets for each event reservation and attend an unlimited
                    number
                    of available shows and events offered through SeatStir located in your local metro area.
                                </p>
                    <ul className="list-unstyled li-space-lg">
                      <li className="media cardBullet">
                        <i className="fas fa-square greenbullet"></i>
                        <div >Bring Friends & Family</div>
                      </li>
                      <li className="media cardBullet">
                        <i className="fas fa-square greenbullet"></i>
                        <div>Sit together guarantee</div>
                      </li>
                    </ul>
                    <p className="price"><span>$25</span> monthly</p>
                  </div>
                  <div className="button-container">
                    <a className="btn-solid-reg page-scroll" href="/memberships">JOIN</a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="basic-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12" id="theTeamHeader">
                <h2 className="animate__animated animate__tada animate__slower">The Team</h2>
                <span>A family owned-and-operated business.</span>
                <br />
                <span className="p-heading"> Headquartered in Las Vegas - The Entertainment Capital of the World</span>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="team-member">
                  <div className="image-wrapper">
                    <img className="img-fluid" id="owners" src={Jim} alt="alternative" />
                  </div>
                  <p className="p-large">Jim Gillette</p>
                  <p className="job-title">Founder - CEO</p>
                  <span className="social-icons">
                    <span className="fa-stack">
                      <a href="#your-link">
                        <span className="hexagon"></span>
                        <i className="fab fa-facebook-f fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="#your-link">
                        <span className="hexagon"></span>
                        <i className="fab fa-twitter fa-stack-1x"></i>
                      </a>
                    </span>
                  </span>
                </div>
                <div className="team-member">
                  <div className="image-wrapper">
                    <img className="img-fluid" id="owners" src={beth} alt="alternative" />
                  </div>
                  <p className="p-large">Beth Gillette</p>
                  <p className="job-title">Co-Founder - CPO</p>
                  <span className="social-icons">
                    <span className="fa-stack">
                      <a href="#your-link">
                        <span className="hexagon"></span>
                        <i className="fab fa-facebook-f fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="#your-link">
                        <span className="hexagon"></span>
                        <i className="fab fa-twitter fa-stack-1x"></i>
                      </a>
                    </span>
                  </span>
                </div>
                <div className="team-member">
                  <div className="image-wrapper">
                    <img className="img-fluid" id="owners" src={karl} alt="alternative" />
                  </div>
                  <p className="p-large">Karl Barth</p>
                  <p className="job-title">Co-founder - VP</p>
                  <span className="social-icons">
                    <span className="fa-stack">
                      <a href="#your-link">
                        <span className="hexagon"></span>
                        <i className="fab fa-facebook-f fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="#your-link">
                        <span className="hexagon"></span>
                        <i className="fab fa-twitter fa-stack-1x"></i>
                      </a>
                    </span>
                  </span>
                </div>
                <div className="team-member">
                  <div className="image-wrapper">
                    <img className="img-fluid" id="owners" src={logan} alt="alternative" />
                  </div>
                  <p className="p-large">Logan Gayler</p>
                  <p className="job-title">Lead Developer</p>
                  <span className="social-icons">
                    <span className="fa-stack">
                      <a href="https://www.facebook.com/logannnnnnnnnnnn" target="_blank" rel="noreferrer">
                        <span className="hexagon"></span>
                        <i className="fab fa-facebook-f fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="https://twitter.com/Logi_G">
                        <span className="hexagon"></span>
                        <i className="fab fa-twitter fa-stack-1x"></i>
                      </a>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ABOUT */}
        <div id="about" className="counter">
          <div className="container">
            <div className="row" id="aboutRow">
              <div className="col-lg-5 col-xl-6" id="aboutCol">
                <div className="image-container">
                  <img className="img-fluid" id="standUpImg" src={aboutUs} alt="alternative" />
                </div>
              </div>
              <div className="col-lg-7 col-xl-6" id="aboutColText">
                <div className="text-container">
                  <div className="section-title">A bit about us</div>
                  <h2>We're Passionate About Entertainment</h2>
                  <p>
                    Seat filling is still a fairly new concept in many areas. That said, the idea behind Seatstir has been around for many
                    years in cities like Las Vegas, New York, and Los Angeles. We've learned
                    that no venue, theater, or stadium is too big or too small when it comes to filling otherwise empty seats. A full house is important for
                    everyone including the performers and paid ticket holders. At Seatstir it is our mission
                    to get folks out, to assist in the exploration of experiences and
                    new happenings in their communities with thier friends and families!
                            </p>
                  <ul className="list-unstyled li-space-lg">
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">A single show can more than pay for the price of membership
                                    </div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Each season brings a new variety of events
                                    </div>
                    </li>
                  </ul>
                  <div id="counter">
                    {/* <div id="shiva"><span id="showCount">500</span></div> */}
                    <div className="cell">
                      <span className="counter-value number-count" data-count="10844">10,844</span>
                      <span className="counterNumber">Events Offered</span>
                    </div>
                    <div className="cell">
                      <span className="counter-value number-count" data-count="821650">821,650</span>
                      <span className="counterNumber">Seats Filled</span>
                    </div>
                    <div className="cell">
                      <span className="counter-value number-count" data-count="804">804</span>
                      <span className="counterNumber">Venue Partnerships</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Home